"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const design_player_avatar_1 = require("@unboared/design.player.avatar");
const design_player_username_1 = require("@unboared/design.player.username");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
function Player({ username, avatar, color, size = 40, style, avatarStyle, usernameStyle, master }) {
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    return (react_1.default.createElement(react_native_1.View, { style: [styles.player, style] },
        react_1.default.createElement(react_native_1.View, { style: styles.avatar },
            react_1.default.createElement(design_player_avatar_1.Avatar, { style: avatarStyle, name: avatar, color: color, size: size })),
        react_1.default.createElement(react_native_1.View, { style: [styles.username, { marginLeft: normalize(size / 4) }] },
            react_1.default.createElement(design_player_username_1.Username, { textStyle: usernameStyle, name: username, size: size / 3, master: master }))));
}
exports.Player = Player;
const styles = react_native_1.StyleSheet.create({
    player: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    avatar: {},
    username: {},
});
//# sourceMappingURL=player.js.map